import { render, staticRenderFns } from "./assignedExaminations.vue?vue&type=template&id=09ee2e5a"
import script from "./assignedExaminations.vue?vue&type=script&lang=js"
export * from "./assignedExaminations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports